import { GridResolutionNames } from "../model/grid";
import { workspaceStore } from "../stores/WorkspaceStore";
import { RydKeybindingTypes } from "./common";


export namespace GridKB {
    export type KeybindingHandlers = {
        increaseGridResolution: RydKeybindingTypes.VoidHandler,
        decreaseGridResolution: RydKeybindingTypes.VoidHandler,
        resetGridResolution: RydKeybindingTypes.VoidHandler
    };

    export function create(): KeybindingHandlers {

        return {
            increaseGridResolution: () => {
                const old = workspaceStore.getState().uiState.gridResolution;
                const index = GridResolutionNames.findIndex((r) => r === old);
                if (index < 0 || index >= GridResolutionNames.length - 1) return;
                const newResolution = GridResolutionNames[index + 1];
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, gridResolution: newResolution });
            },
            decreaseGridResolution: () => {
                const old = workspaceStore.getState().uiState.gridResolution;
                const index = GridResolutionNames.findIndex((r) => r === old);
                if (index <= 0) return;
                const newResolution = GridResolutionNames[index - 1];
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, gridResolution: newResolution });
            },
            resetGridResolution: () => {
                const defaultResolution = 'BAR';
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, gridResolution: defaultResolution });
            }
        };
    }
}
